import React from 'react';
import ProtectedImage from '../../components/ProtectedImage';
import CanvasImage from '../../components/CanvasImage';
import './ImageProtectionTest.css';

const ImageProtectionTest = () => {
  const testImages = [
    'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=800&q=80',
    'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800&q=80',
    'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80',
    'https://images.unsplash.com/photo-1559592413-7cec4d0cae2b?w=800&q=80'
  ];

  return (
    <div className="image-protection-test">
      <div className="container">
        <h1>Image Protection Test Page</h1>
        <p>Try to right-click, drag, or inspect these images!</p>
        
        <section className="test-section">
          <h2>Regular Protected Images</h2>
          <div className="image-grid">
            {testImages.map((src, index) => (
              <div key={index} className="image-item">
                <h3>Protected Image {index + 1}</h3>
                <ProtectedImage
                  src={src}
                  alt={`Protected test image ${index + 1}`}
                  style={{ width: '100%', maxWidth: '400px', height: '250px', objectFit: 'cover' }}
                />
                <p>✅ Right-click disabled, drag blocked</p>
              </div>
            ))}
          </div>
        </section>

        <section className="test-section">
          <h2>Canvas-Based Protected Images (High Security)</h2>
          <div className="image-grid">
            {testImages.slice(0, 2).map((src, index) => (
              <div key={index} className="image-item">
                <h3>Canvas Image {index + 1}</h3>
                <CanvasImage
                  src={src}
                  alt={`Canvas protected test ${index + 1}`}
                  watermarkText="SAFARNAMAH.COM"
                  style={{ width: '100%', maxWidth: '400px' }}
                />
                <p>🔒 Canvas-based, noise added for protection</p>
              </div>
            ))}
          </div>
        </section>

        <section className="test-section">
          <h2>Regular Image (For Comparison)</h2>
          <div className="image-item">
            <h3>Unprotected Image</h3>
            <img 
              src={testImages[0]}
              alt="Regular unprotected content"
              style={{ width: '100%', maxWidth: '400px', height: '250px', objectFit: 'cover' }}
            />
            <p>❌ No protection - right-click works</p>
          </div>
        </section>

        <div className="protection-info">
          <h2>Protection Features Active:</h2>
          <ul>
            <li>🚫 Right-click context menu disabled</li>
            <li>🚫 Drag and drop disabled</li>
            <li>🚫 Text selection disabled</li>
            <li>🚫 Keyboard shortcuts blocked (F12, Ctrl+Shift+I, etc.)</li>
            <li>🔍 DevTools detection</li>
            <li>🎨 Canvas conversion (for high-security images)</li>
            <li>📱 Mobile long-press disabled</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ImageProtectionTest;